import React from 'react';

// Rough placeholder badge (plan §5 "Icon fidelity") -- intentionally not pixel-tuned, meant to be
// hand-replaced later.
const FileZipBadgeIcon = () => (
  <svg data-dc-tpl="227" width="64" height="64" viewBox="0 0 60 64" fill="none"
       aria-hidden="true">
    <path data-dc-tpl="228"
          d="M14 4h24l12 12v40a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4Z"
          fill="#fff" stroke="#07132B" stroke-width="2.5"
          stroke-linejoin="round"></path>
    <path data-dc-tpl="229" d="M38 4v8a4 4 0 0 0 4 4h8" fill="none"
          stroke="#07132B" stroke-width="2.5" stroke-linejoin="round"></path>
    <path data-dc-tpl="230" d="M30 4v4m0 4v4m0 4v4" stroke="#B8860B"
          stroke-width="3"></path>
    <path data-dc-tpl="231" d="M26 6h4m0 4h4m-8 4h4m0 4h4m-8 4h4"
          stroke="#B8860B" stroke-width="2.5" stroke-linecap="round"></path>
    <rect data-dc-tpl="232" x="26" y="26" width="8" height="8" rx="2"
          fill="#FFF4D6" stroke="#B8860B" stroke-width="2"></rect>
    <rect data-dc-tpl="233" x="2" y="38" width="40" height="18" rx="6"
          fill="#F2B705" stroke="#07132B" stroke-width="2.5"></rect>
    <text data-dc-tpl="234" x="22" y="51.5" text-anchor="middle"
          font-family="Plus Jakarta Sans, sans-serif" font-size="11"
          font-weight="800" fill="#07132B" letter-spacing=".5">ZIP
    </text>
  </svg>
);

export default FileZipBadgeIcon;
